/* tslint:disable */
/* eslint-disable */
/**
 * Wings Server
 * A backend for birds database.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: li3p@xmbirds.cn
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuizOption
 */
export interface QuizOption {
    /**
     * 
     * @type {number}
     * @memberof QuizOption
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof QuizOption
     */
    title: string;
}

export function QuizOptionFromJSON(json: any): QuizOption {
    return QuizOptionFromJSONTyped(json, false);
}

export function QuizOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuizOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'title': json['title'],
    };
}

export function QuizOptionToJSON(value?: QuizOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'title': value.title,
    };
}


